import LTR from "@brand-icons/global/product-package-multiple/product-package-multiple-ltr.svg";
import RTL from "@brand-icons/global/product-package-multiple/product-package-multiple-rtl.svg";

import { iconFactory } from "../iconFactory";

export const ProductPackageMultipleIcon = iconFactory("ProductPackageMultipleIcon", LTR, RTL);
